<template>
  <div>
    <div class="pgemnt-4">
      <div class="ttBar">
        <span>统计数据生成</span>
      </div>
      <div class="tabArea">
        <div class="titleH">汇总表</div>
        <div class="seekArea" style="margin-bottom: 10px">
          <el-button type="primary" @click="initBase()" size="mini">初始化基本信息</el-button>
          <el-button type="primary" @click="initFinance()" size="mini">初始化经营情况</el-button>
          <el-button type="primary" @click="initPublication()" size="mini">初始化出版物</el-button>
          <el-button type="primary" @click="initWorker()" size="mini">初始化人员</el-button>
        </div>
        <div class="seekArea" style="margin-bottom: 10px">
          <el-button type="primary" @click="initLxdzBase()" size="mini">连续型-初始化单位信息</el-button>
          <el-button type="primary" @click="initLxdzFinance()" size="mini">连续型-初始化经营情况</el-button>
        </div>
        <div class="seekArea" style="margin-bottom: 10px">
          <el-button type="primary" @click="batchAuditGen()" size="mini">审核判断数据生成</el-button>
        </div>
        <div class="seekArea" style="margin-bottom: 10px"></div>
        <!-- <el-button type="danger" @click="initHzbWorker()" size="mini">初始化人员</el-button> -->
      </div>
    </div>
  </div>
</template>

<script>
import {
  initBase,
  initFinance,
  initPublication,
  initWorker,
  initLxdzBase,
  initLxdzFinance,
} from "@/api/pgMent/sectStatic";
import {
  batchAuditGen, // zym.省局：批量生成审核的条件数据
} from "@/api/provinceRole/provinceRole";

import initPagin from "@/mixins/initPagin";
export default {
  mixins: [initPagin],
  props: {
    hidePagin: { type: Boolean, default: false },
  },
  data() {
    return {
      loading: false,
      param: {},
    };
  },
  watch: {},
  filters: {
    translate: function (dat, code, map) {},
  },
  methods: {
    // zym.基本信息初始化
    initBase: function () {
      let tipMsg = `<span style='font-weight:bold;color:red'>此操作会删除原来的数据，请谨慎操作，是否继续?</span>`;
      this.$confirm(tipMsg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        dangerouslyUseHTMLString: true,
        type: "warning",
      })
        .then(() => {
          const loading = this.$loading({
            lock: true,
            text: "处理中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          let dataIn = {};
          initBase({ dataIn }).then((response) => {
            console.log("response=", response);
            let code = (response || {}).code;
            let msg = (response || {}).message || "处理失败";
            if (code == "success") {
              loading.close();
              this.$message({
                type: "success",
                message: msg,
              });
            } else {
              loading.close();
              this.$message({
                type: "error",
                message: msg,
              });
            }
          });
        })
        .catch((e) => {
          console.log("测试...", e);
          const loading = this.$loading({
            lock: true,
            text: "处理中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          loading.close();
        });
    },

    // zym.基本信息初始化 - 连续型
    initLxdzBase: function () {
      let tipMsg = `<span style='font-weight:bold;color:red'>此操作会删除原来的数据，请谨慎操作，是否继续?</span>`;
      this.$confirm(tipMsg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        dangerouslyUseHTMLString: true,
        type: "warning",
      })
        .then(() => {
          const loading = this.$loading({
            lock: true,
            text: "处理中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          let dataIn = {};
          initLxdzBase({ dataIn }).then((response) => {
            console.log("response=", response);
            let code = (response || {}).code;
            let msg = (response || {}).message || "处理失败";
            if (code == "success") {
              loading.close();
              this.$message({
                type: "success",
                message: msg,
              });
            } else {
              loading.close();
              this.$message({
                type: "error",
                message: msg,
              });
            }
          });
        })
        .catch((e) => {
          console.log("测试...", e);
          const loading = this.$loading({
            lock: true,
            text: "处理中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          loading.close();
        });
    },
    // zym.经营情况初始化
    initFinance: function () {
      let tipMsg = `<span style='font-weight:bold;color:red'>此操作会删除原来的数据，请谨慎操作，是否继续?</span>`;
      this.$confirm(tipMsg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        dangerouslyUseHTMLString: true,
        type: "warning",
      })
        .then(() => {
          const loading = this.$loading({
            lock: true,
            text: "处理中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          let dataIn = {};
          initFinance({ dataIn }).then((response) => {
            console.log("response=", response);
            let code = (response || {}).code;
            let msg = (response || {}).message || "处理失败";
            if (code == "success") {
              loading.close();
              this.$message({
                type: "success",
                message: msg,
              });
            } else {
              loading.close();
              this.$message({
                type: "error",
                message: msg,
              });
            }
          });
        })
        .catch((e) => {
          console.log("测试...", e);
          const loading = this.$loading({
            lock: true,
            text: "处理中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          loading.close();
        });
    },
    // zym.经营情况初始化 - 连续电子
    initLxdzFinance: function () {
      let tipMsg = `<span style='font-weight:bold;color:red'>此操作会删除原来的数据，请谨慎操作，是否继续?</span>`;
      this.$confirm(tipMsg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        dangerouslyUseHTMLString: true,
        type: "warning",
      })
        .then(() => {
          const loading = this.$loading({
            lock: true,
            text: "处理中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          let dataIn = {};
          initLxdzFinance({ dataIn }).then((response) => {
            console.log("response=", response);
            let code = (response || {}).code;
            let msg = (response || {}).message || "处理失败";
            if (code == "success") {
              loading.close();
              this.$message({
                type: "success",
                message: msg,
              });
            } else {
              loading.close();
              this.$message({
                type: "error",
                message: msg,
              });
            }
          });
        })
        .catch((e) => {
          console.log("测试...", e);
          const loading = this.$loading({
            lock: true,
            text: "处理中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          loading.close();
        });
    },
    // zym.作品初始化
    initPublication: function () {
      let tipMsg = `<span style='font-weight:bold;color:red'>此操作会删除原来的数据，请谨慎操作，是否继续?</span>`;
      this.$confirm(tipMsg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        dangerouslyUseHTMLString: true,
        type: "warning",
      })
        .then(() => {
          const loading = this.$loading({
            lock: true,
            text: "处理中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          let dataIn = {};
          initPublication({ dataIn }).then((response) => {
            console.log("response=", response);
            let code = (response || {}).code;
            let msg = (response || {}).message || "处理失败";
            if (code == "success") {
              loading.close();
              this.$message({
                type: "success",
                message: msg,
              });
            } else {
              loading.close();
              this.$message({
                type: "error",
                message: msg,
              });
            }
          });
        })
        .catch((e) => {
          console.log("测试...", e);
          const loading = this.$loading({
            lock: true,
            text: "处理中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          loading.close();
        });
    },
    // zym.人员初始化
    initWorker: function () {
      let tipMsg = `<span style='font-weight:bold;color:red'>此操作会删除原来的数据，请谨慎操作，是否继续?</span>`;
      this.$confirm(tipMsg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        dangerouslyUseHTMLString: true,
        type: "warning",
      })
        .then(() => {
          const loading = this.$loading({
            lock: true,
            text: "处理中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          let dataIn = {};
          initWorker({ dataIn }).then((response) => {
            console.log("response=", response);
            let code = (response || {}).code;
            let msg = (response || {}).message || "处理失败";
            if (code == "success") {
              loading.close();
              this.$message({
                type: "success",
                message: msg,
              });
            } else {
              loading.close();
              this.$message({
                type: "error",
                message: msg,
              });
            }
          });
        })
        .catch((e) => {
          console.log("测试...", e);
          const loading = this.$loading({
            lock: true,
            text: "处理中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          loading.close();
        });
    },
    // zym.省局：批量生成审核的条件数据
    batchAuditGen: function () {
      let tipMsg = `<span style='font-weight:bold;color:red'>此操作会自动生成审核判断条件，是否确定生成?</span>`;
      this.$confirm(tipMsg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        dangerouslyUseHTMLString: true,
        type: "warning",
      })
        .then(() => {
          const loading = this.$loading({
            lock: true,
            text: "处理中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          let dataIn = {};
          batchAuditGen({ dataIn }).then((response) => {
            console.log("response=", response);
            let code = (response || {}).code;
            let msg = (response || {}).message || "处理失败";
            if (code == "success") {
              loading.close();
              this.$message({
                type: "success",
                message: msg,
              });
            } else {
              loading.close();
              this.$message({
                type: "error",
                message: msg,
              });
            }
          });
        })
        .catch((e) => {
          const loading = this.$loading({
            lock: true,
            text: "处理中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          loading.close();
        });
    },
  },
  created: function () {},
};
</script>

<style lang="scss" scoped>
.tabArea {
  margin-top: 12px;

  .seekArea {
    margin-bottom: 12px;

    .el-input {
      input {
        border-radius: 0px;
      }
    }
  }

  .pageCage {
    text-align: center;
    margin: 30px auto;
  }
}
.pgemnt-4 {
  padding: 6px 30px;
}

.pgemnt-4 .goDeeper {
  cursor: pointer;
}

.pgemnt-4-dag .el-dialog__header {
  padding: 20px 18px 25px;
}

.pgemnt-4-dag .el-dialog__body {
  padding: 0px 30px;
  margin-bottom: 12px;
}

.pgemnt-4-dag .el-dialog__footer {
  padding-bottom: 30px;
}

.pgemnt-4-dag table {
  width: 100%;
  margin-top: 12px;
}

.pgemnt-4-dag table td {
  padding-bottom: 12px;
}

.pgemnt-4 .inpName {
  text-align: right;
  width: 60px;
  padding-right: 15px;
}

.pgemnt-4 .inpGup {
  margin-bottom: 12px;
  height: 45px;
  background: salmon;
}

.pgemnt-4 .newAdd {
  width: 90px;
}
</style>



// WEBPACK FOOTER //
// sectStatic.vue?36a57f52